window.$ = window.jQuery = require('jquery');
import $ from 'jquery';

const slider = (function () {

  function _isElementVisible(element) {
    var rect = element.getBoundingClientRect(),
      vWidth = window.innerWidth || doc.documentElement.clientWidth,
      vHeight = window.innerHeight || doc.documentElement.clientHeight,
      elemFromPoint = function (x, y) { return document.elementFromPoint(x, y); };
    if (rect.right < 0 || rect.bottom < 0
      || rect.left > vWidth || rect.top > vHeight)
      return false;
    return (
      element.contains(elemFromPoint(rect.left, rect.top))
      || element.contains(elemFromPoint(rect.right, rect.top))
      || element.contains(elemFromPoint(rect.right, rect.bottom))
      || element.contains(elemFromPoint(rect.left, rect.bottom))
    );
  }

  return function (selector, config) {
    var
      _mainElement = document.querySelector(selector), // основный элемент блока
      _sliderWrapper = _mainElement.querySelector('.slider__wrapper'), // обертка для .slider-item
      _sliderItems = _mainElement.querySelectorAll('.slider__item'), // элементы (.slider-item)
      // _sliderControls = _mainElement.querySelectorAll('.slider__control'), // элементы управления
      // _sliderControlLeft = _mainElement.querySelector('.slider__control_left'), // кнопка "LEFT"
      // _sliderControlRight = _mainElement.querySelector('.slider__control_right'), // кнопка "RIGHT"
      _wrapperWidth = parseFloat(getComputedStyle(_sliderWrapper).width), // ширина обёртки
      _itemWidth = parseFloat(getComputedStyle(_sliderItems[0]).width), // ширина одного элемента
      _positionLeftItem = 0, // позиция левого активного элемента
      _transform = 0, // значение транфсофрмации .slider_wrapper
      _step = _itemWidth / _wrapperWidth * 100, // величина шага (для трансформации)
      _items = [], // массив элементов
      _interval = 0,
      _html = _mainElement.innerHTML,
      _states = [
        { active: false, minWidth: 0, count: 1 },
        { active: false, minWidth: 980, count: 2 }
      ],
      _config = {
        isCycling: false, // автоматическая смена слайдов
        direction: 'right', // направление смены слайдов
        interval: 5000, // интервал между автоматической сменой слайдов
        pause: true // устанавливать ли паузу при поднесении курсора к слайдеру
      };

    for (var key in config) {
      if (key in _config) {
        _config[key] = config[key];
      }
    }

    // наполнение массива _items
    _sliderItems.forEach(function (item, index) {
      _items.push({ item: item, position: index, transform: 0 });
    });

    var _setActive = function () {
      var _index = 0;
      var width = parseFloat(document.body.clientWidth);
      _states.forEach(function (item, index) {
        _states[index].active = false;
        if (width >= _states[index].minWidth)
          _index = index;
      });
      _states[_index].active = true;
    };

    var _getActive = function () {
      var _index;
      _states.forEach(function (item, index) {
        if (_states[index].active) {
          _index = index;
        }
      });
      return _index;
    };

    var position = {
      getItemMin: function () {
        var indexItem = 0;
        _items.forEach(function (item, index) {
          if (item.position < _items[indexItem].position) {
            indexItem = index;
          }
        });
        return indexItem;
      },
      getItemMax: function () {
        var indexItem = 0;
        _items.forEach(function (item, index) {
          if (item.position > _items[indexItem].position) {
            indexItem = index;
          }
        });
        return indexItem;
      },
      getMin: function () {
        return _items[position.getItemMin()].position;
      },
      getMax: function () {
        return _items[position.getItemMax()].position;
      }
    };

    var _transformItem = function (direction) {
      var nextItem;
      if (!_isElementVisible(_mainElement)) {
        return;
      }
      if (direction === 'right') {
        _positionLeftItem++;
        if ((_positionLeftItem + _wrapperWidth / _itemWidth - 1) > position.getMax()) {
          nextItem = position.getItemMin();
          _items[nextItem].position = position.getMax() + 1;
          _items[nextItem].transform += _items.length * 100;
          _items[nextItem].item.style.transform = 'translateX(' + _items[nextItem].transform + '%)';
        }
        _transform -= _step;
      }
      if (direction === 'left') {
        _positionLeftItem--;
        if (_positionLeftItem < position.getMin()) {
          nextItem = position.getItemMax();
          _items[nextItem].position = position.getMin() - 1;
          _items[nextItem].transform -= _items.length * 100;
          _items[nextItem].item.style.transform = 'translateX(' + _items[nextItem].transform + '%)';
        }
        _transform += _step;
      }
      _sliderWrapper.style.transform = 'translateX(' + _transform + '%)';
    };

    var _cycle = function (direction) {
      if (!_config.isCycling) {
        return;
      }
      _interval = setInterval(function () {
        _transformItem(direction);
      }, _config.interval);
    };

    // обработчик события click для кнопок "назад" и "вперед"
    var _controlClick = function (e) {
      if (e.target.classList.contains('slider__control')) {
        e.preventDefault();
        var direction = e.target.classList.contains('slider__control_right') ? 'right' : 'left';
        _transformItem(direction);
        clearInterval(_interval);
        _cycle(_config.direction);
      }
    };

    // обработка события изменения видимости страницы
    var _handleVisibilityChange = function () {
      if (document.visibilityState === 'hidden') {
        clearInterval(_interval);
      } else {
        clearInterval(_interval);
        _cycle(_config.direction);
      }
    };

    var _refresh = function () {
      clearInterval(_interval);
      _mainElement.innerHTML = _html;
      _sliderWrapper = _mainElement.querySelector('.slider__wrapper');
      _sliderItems = _mainElement.querySelectorAll('.slider__item');
      // _sliderControls = _mainElement.querySelectorAll('.slider__control');
      // _sliderControlLeft = _mainElement.querySelector('.slider__control_left');
      // _sliderControlRight = _mainElement.querySelector('.slider__control_right');
      _wrapperWidth = parseFloat(getComputedStyle(_sliderWrapper).width);
      _itemWidth = parseFloat(getComputedStyle(_sliderItems[0]).width);
      _positionLeftItem = 0;
      _transform = 0;
      _step = _itemWidth / _wrapperWidth * 100;
      _items = [];
      _sliderItems.forEach(function (item, index) {
        _items.push({ item: item, position: index, transform: 0 });
      });
    };

    var _setUpListeners = function () {
      _mainElement.addEventListener('click', _controlClick);
      if (_config.pause && _config.isCycling) {
        _mainElement.addEventListener('mouseenter', function () {
          clearInterval(_interval);
        });
        _mainElement.addEventListener('mouseleave', function () {
          clearInterval(_interval);
          _cycle(_config.direction);
        });
      }
      document.addEventListener('visibilitychange', _handleVisibilityChange, false);
      window.addEventListener('resize', function () {
        var
          _index = 0,
          width = parseFloat(document.body.clientWidth);
        _states.forEach(function (item, index) {
          if (width >= _states[index].minWidth)
            _index = index;
        });
        if (_index !== _getActive()) {
          _setActive();
          _refresh();
        }
      });
    };

    // инициализация
    _setUpListeners();
    if (document.visibilityState === 'visible') {
      _cycle(_config.direction);
    }
    _setActive();

    return {
      right: function () { // метод right
        _transformItem('right');
      },
      left: function () { // метод left
        _transformItem('left');
      },
      stop: function () { // метод stop
        _config.isCycling = false;
        clearInterval(_interval);
      },
      cycle: function () { // метод cycle
        _config.isCycling = true;
        clearInterval(_interval);
        _cycle();
      }
    };

  };
}());

$(document).ready(function() {
  const sliderElement = document.getElementsByClassName('slider');
  if (sliderElement.length > 0) {
    slider('.slider', {
      isCycling: true
    });
  }

  const getNavbarOffset = function() {
    const nav = document.getElementById('top-nav');
    return nav ? nav.offsetHeight + 8 : 78;
  };

  const scrollToHash = function(hash, behavior) {
    if (!hash || hash === '#') {
      return false;
    }

    const target = document.querySelector(hash);
    if (!target) {
      return false;
    }

    const top = target.getBoundingClientRect().top + window.pageYOffset - getNavbarOffset();
    window.scrollTo({
      top: top,
      behavior: behavior || 'smooth'
    });

    return true;
  };

  const normalizePath = function(pathname) {
    const path = (pathname || '/').replace(/\/+$/, '');
    return path === '' ? '/' : path;
  };

  const isSamePageLink = function(href) {
    try {
      const url = new URL(href, window.location.origin);
      return normalizePath(url.pathname) === normalizePath(window.location.pathname);
    } catch (e) {
      return false;
    }
  };

  const navPanel = document.getElementById('site-nav-panel');
  const navToggle = document.getElementById('site-nav-toggle');
  const siteNav = document.getElementById('top-nav');
  const MOBILE_NAV_MAX = 767;

  const isMobileMenuOpen = function() {
    return Boolean(navPanel && !navPanel.hasAttribute('hidden'));
  };

  const setMobileMenuOpen = function(isOpen) {
    const open = Boolean(isOpen) && window.innerWidth <= MOBILE_NAV_MAX;

    document.body.classList.toggle('overflow-hidden', open);

    if (navPanel) {
      if (open) {
        navPanel.removeAttribute('hidden');
      } else {
        navPanel.setAttribute('hidden', '');
      }
    }

    if (navToggle) {
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  };

  const closeMobileMenu = function() {
    setMobileMenuOpen(false);
  };

  if (navToggle && navPanel) {
    navToggle.addEventListener('click', function() {
      setMobileMenuOpen(!isMobileMenuOpen());
    });

    navPanel.addEventListener('click', function(event) {
      if (event.target.closest('[data-nav-close]')) {
        closeMobileMenu();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && isMobileMenuOpen()) {
        closeMobileMenu();
      }
    });
  }

  if (siteNav) {
    const onScroll = function() {
      siteNav.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Progressively hide trailing desktop links when the bar is too narrow.
  // Full list remains available in the mobile drawer.
  (function initPriorityNav() {
    const root = document.querySelector('[data-nav-priority]');
    const primary = root && root.querySelector('[data-nav-primary]');
    if (!root || !primary) {
      return;
    }

    const overflows = function() {
      return primary.scrollWidth > primary.clientWidth + 1;
    };

    const reconcile = function() {
      const items = Array.prototype.slice.call(
        primary.querySelectorAll(':scope > [data-nav-item]')
      );

      items.forEach(function(item) {
        item.removeAttribute('hidden');
      });

      if (window.innerWidth <= MOBILE_NAV_MAX) {
        return;
      }

      let guard = items.length;
      while (overflows() && guard-- > 0) {
        const visible = items.filter(function(item) {
          return !item.hasAttribute('hidden');
        });
        if (!visible.length) {
          break;
        }
        visible[visible.length - 1].setAttribute('hidden', '');
      }
    };

    let frame = 0;
    const schedule = function() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(reconcile);
    };

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(schedule);
      observer.observe(root);
      if (siteNav) {
        observer.observe(siteNav);
      }
    }

    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    schedule();
  })();

  window.addEventListener('resize', function() {
    if (window.innerWidth > MOBILE_NAV_MAX) {
      closeMobileMenu();
    }
  });

  const menuElementsList = document.getElementsByClassName('pagescroll');
  for (let i = 0; menuElementsList.length > i; i++) {
    menuElementsList[i].addEventListener('click', function(event) {
      const href = this.getAttribute('href') || '';
      const hashIndex = href.indexOf('#');

      closeMobileMenu();

      if (hashIndex === -1) {
        return;
      }

      const hash = href.slice(hashIndex);

      // Already on the target page — smooth-scroll instead of jump reload
      if (isSamePageLink(href) && document.querySelector(hash)) {
        event.preventDefault();
        scrollToHash(hash, 'smooth');
        if (history.pushState) {
          history.pushState(null, '', hash);
        }
      }
    });
  }

  // Arrive from another page with /#video or /#gallery
  if (window.location.hash) {
    setTimeout(function() {
      scrollToHash(window.location.hash, 'auto');
    }, 50);
  }
});

(function initSiteLightbox() {
  var root = null;
  var stage = null;
  var btnPrev = null;
  var btnNext = null;
  var counter = null;
  var items = [];
  var index = 0;
  var mode = 'image';
  var lastFocus = null;

  function ensureDom() {
    if (root) {
      return;
    }

    root = document.createElement('div');
    root.className = 'site-lightbox';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="site-lightbox__backdrop" data-lightbox-close></div>' +
      '<div class="site-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Media">' +
        '<button type="button" class="site-lightbox__close" data-lightbox-close aria-label="Close"><i class="ti ti-x" aria-hidden="true"></i></button>' +
        '<button type="button" class="site-lightbox__nav site-lightbox__nav--prev" data-lightbox-prev aria-label="Previous"><i class="ti ti-chevron-left" aria-hidden="true"></i></button>' +
        '<button type="button" class="site-lightbox__nav site-lightbox__nav--next" data-lightbox-next aria-label="Next"><i class="ti ti-chevron-right" aria-hidden="true"></i></button>' +
        '<div class="site-lightbox__stage"></div>' +
        '<p class="site-lightbox__counter" hidden></p>' +
      '</div>';

    document.body.appendChild(root);
    stage = root.querySelector('.site-lightbox__stage');
    btnPrev = root.querySelector('[data-lightbox-prev]');
    btnNext = root.querySelector('[data-lightbox-next]');
    counter = root.querySelector('.site-lightbox__counter');

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-lightbox-close]')) {
        close();
      } else if (event.target.closest('[data-lightbox-prev]')) {
        show(index - 1);
      } else if (event.target.closest('[data-lightbox-next]')) {
        show(index + 1);
      }
    });
  }

  function youtubeId(url) {
    var match = String(url).match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);
    return match && match[7] && match[7].length === 11 ? match[7] : null;
  }

  function vimeoId(url) {
    var match = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : null;
  }

  function embedUrl(url) {
    var yt = youtubeId(url);
    if (yt) {
      return 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0';
    }
    var vm = vimeoId(url);
    if (vm) {
      return 'https://player.vimeo.com/video/' + vm + '?autoplay=1';
    }
    return null;
  }

  function lockScroll(locked) {
    document.documentElement.classList.toggle('site-lightbox-open', locked);
    document.body.classList.toggle('site-lightbox-open', locked);
  }

  function updateNav() {
    var multi = items.length > 1;
    btnPrev.hidden = !multi;
    btnNext.hidden = !multi;
    if (multi) {
      counter.hidden = false;
      counter.textContent = (index + 1) + ' / ' + items.length;
    } else {
      counter.hidden = true;
    }
  }

  function show(nextIndex) {
    if (!items.length) {
      return;
    }

    index = (nextIndex + items.length) % items.length;
    var item = items[index];
    stage.innerHTML = '';

    if (mode === 'video') {
      root.classList.add('is-video');
      root.classList.remove('is-image');
      var src = embedUrl(item.src);
      if (!src) {
        window.open(item.src, '_blank', 'noopener');
        close();
        return;
      }
      var frame = document.createElement('iframe');
      frame.className = 'site-lightbox__frame';
      frame.src = src;
      frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('title', item.title || 'Video');
      stage.appendChild(frame);
    } else {
      root.classList.add('is-image');
      root.classList.remove('is-video');
      var img = document.createElement('img');
      img.className = 'site-lightbox__img';
      img.src = item.src;
      img.alt = item.title || '';
      stage.appendChild(img);
    }

    updateNav();
  }

  function open(list, startIndex, openMode) {
    ensureDom();
    items = list;
    mode = openMode;
    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    root.classList.add('is-open');
    lockScroll(true);
    show(startIndex || 0);
    root.querySelector('.site-lightbox__close').focus();
  }

  function close() {
    if (!root || root.hasAttribute('hidden')) {
      return;
    }
    root.setAttribute('hidden', '');
    root.classList.remove('is-open', 'is-video', 'is-image');
    stage.innerHTML = '';
    items = [];
    lockScroll(false);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function collectFrom(anchor, selectorScope) {
    var list = [];
    var nodes;
    if (selectorScope) {
      nodes = selectorScope.querySelectorAll('a[href]');
    } else {
      nodes = [anchor];
    }
    Array.prototype.forEach.call(nodes, function (node) {
      list.push({
        src: node.getAttribute('href'),
        title: node.getAttribute('title') || node.querySelector('img') && node.querySelector('img').getAttribute('alt') || '',
      });
    });
    return list;
  }

  document.addEventListener('click', function (event) {
    var videoLink = event.target.closest('a.popup-for-video');
    if (videoLink) {
      event.preventDefault();
      open([{ src: videoLink.getAttribute('href'), title: videoLink.getAttribute('aria-label') || '' }], 0, 'video');
      return;
    }

    var gallery = event.target.closest('.popup-gallery');
    if (gallery) {
      var galleryLink = event.target.closest('a[href]');
      if (!galleryLink || !gallery.contains(galleryLink)) {
        return;
      }
      event.preventDefault();
      var galleryItems = collectFrom(galleryLink, gallery);
      var start = galleryItems.findIndex(function (item) {
        return item.src === galleryLink.getAttribute('href');
      });
      open(galleryItems, start < 0 ? 0 : start, 'image');
      return;
    }

    var imageLink = event.target.closest('a.popup-for-image');
    if (imageLink) {
      event.preventDefault();
      var group = document.querySelectorAll('a.popup-for-image');
      var imageItems = [];
      Array.prototype.forEach.call(group, function (node) {
        imageItems.push({
          src: node.getAttribute('href'),
          title: node.getAttribute('title') || '',
        });
      });
      var imageStart = imageItems.findIndex(function (item) {
        return item.src === imageLink.getAttribute('href');
      });
      open(imageItems, imageStart < 0 ? 0 : imageStart, 'image');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!root || root.hasAttribute('hidden')) {
      return;
    }
    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'ArrowLeft') {
      show(index - 1);
    } else if (event.key === 'ArrowRight') {
      show(index + 1);
    }
  });
})();

(function initContactDeck() {
  var deck = document.querySelector('[data-contact-deck]');
  if (!deck) {
    return;
  }

  var stack = deck.querySelector('.contact-deck__stack');
  var slides = Array.prototype.slice.call(deck.querySelectorAll('[data-deck-slide]'));
  var dots = Array.prototype.slice.call(deck.querySelectorAll('[data-deck-dot]'));
  var prevBtn = deck.querySelector('[data-deck-prev]');
  var nextBtn = deck.querySelector('[data-deck-next]');
  if (!slides.length) {
    return;
  }

  var index = Math.max(0, slides.findIndex(function (slide) {
    return slide.classList.contains('is-active');
  }));
  var touchStartX = 0;
  var touchStartY = 0;
  var touchActive = false;

  function syncHeight() {
    if (!stack) {
      return;
    }

    var maxHeight = 0;
    slides.forEach(function (slide) {
      var tile = slide.querySelector('.contact-tile');
      if (!tile) {
        return;
      }
      tile.style.height = 'auto';
      maxHeight = Math.max(maxHeight, tile.scrollHeight);
      tile.style.height = '';
    });

    if (maxHeight) {
      stack.style.minHeight = maxHeight + 'px';
    }
  }

  function render() {
    var prev = (index - 1 + slides.length) % slides.length;
    var next = (index + 1) % slides.length;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
      slide.classList.toggle('is-prev', i === prev);
      slide.classList.toggle('is-next', i === next);
    });
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
    syncHeight();
  }

  function go(step) {
    index = (index + step + slides.length) % slides.length;
    render();
  }

  function goTo(nextIndex) {
    if (nextIndex < 0 || nextIndex >= slides.length) {
      return;
    }
    index = nextIndex;
    render();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      go(-1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      go(1);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(Number(dot.getAttribute('data-deck-dot')));
    });
  });

  if (stack) {
    stack.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) {
        return;
      }
      touchActive = true;
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });

    stack.addEventListener('touchend', function (event) {
      if (!touchActive || !event.changedTouches || !event.changedTouches[0]) {
        return;
      }
      touchActive = false;
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) {
        return;
      }
      go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  deck.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') {
      go(-1);
    } else if (event.key === 'ArrowRight') {
      go(1);
    }
  });

  render();
  window.addEventListener('resize', syncHeight);
})();

(function initSiteToasts() {
  function getToastHost() {
    var host = document.querySelector('[data-site-toasts]');
    if (host) {
      return host;
    }
    host = document.createElement('div');
    host.className = 'site-toasts';
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-atomic', 'true');
    host.setAttribute('data-site-toasts', '');
    document.body.appendChild(host);
    return host;
  }

  function hideToast(toast) {
    if (!toast || toast.classList.contains('is-hiding')) {
      return;
    }

    toast.classList.add('is-hiding');
    window.setTimeout(function () {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 250);
  }

  function bindToast(toast, timeoutMs) {
    var hideTimer = window.setTimeout(function () {
      hideToast(toast);
    }, timeoutMs || 5000);

    var closeButton = toast.querySelector('.site-toast__close');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        window.clearTimeout(hideTimer);
        hideToast(toast);
      });
    }
  }

  window.showSiteToast = function (message, type, timeoutMs) {
    if (!message) {
      return;
    }

    var host = getToastHost();
    var toast = document.createElement('div');
    toast.className = 'site-toast site-toast--' + (type || 'success');
    toast.setAttribute('role', 'alert');
    toast.setAttribute('data-autohide', 'true');
    toast.innerHTML =
      '<div class="site-toast__body"></div>' +
      '<button type="button" class="site-toast__close" aria-label="Close"><i class="ti ti-x" aria-hidden="true"></i></button>';
    toast.querySelector('.site-toast__body').textContent = message;
    host.appendChild(toast);
    bindToast(toast, timeoutMs || 2500);
  };

  Array.prototype.forEach.call(document.querySelectorAll('.site-toast[data-autohide="true"]'), function (toast) {
    bindToast(toast, 5000);
  });
})();

(function initCopyButtons() {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy]');
    if (!button) {
      return;
    }

    var value = button.getAttribute('data-copy');
    if (!value) {
      return;
    }

    var copiedLabel = button.getAttribute('data-copied-label') || 'Copied';

    var onCopied = function () {
      button.classList.add('is-copied');
      window.clearTimeout(button._copyTimer);
      button._copyTimer = window.setTimeout(function () {
        button.classList.remove('is-copied');
      }, 1200);

      if (typeof window.showSiteToast === 'function') {
        window.showSiteToast(copiedLabel, 'success', 2500);
      }
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(onCopied).catch(function () {
        fallbackCopy(value, onCopied);
      });
      return;
    }

    fallbackCopy(value, onCopied);
  });

  function fallbackCopy(value, onSuccess) {
    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (error) {
      // ignore
    }
    document.body.removeChild(input);
  }
})();

